import { WithAccountId } from '@mews-commander/types';
import { TextKey } from '@mews-commander/enums';
import { SpacedDash } from '@mews-commander/ui';
import { useLocalizeText } from '@mews/framework';
import { useGetAccountName } from '../../../accounts';
import { PaymentsTabActiveSegment } from './types';

export const usePaymentsTabSegmentTitle = ({
    segment,
    accountId,
}: { segment: PaymentsTabActiveSegment } & WithAccountId) => {
    const localizeText = useLocalizeText();
    const { data: accountName } = useGetAccountName(accountId);
    const segmentTitle = localizeText({ textKey: segmentTitleTextKey[segment] });
    return accountName ? `${accountName}${SpacedDash}${segmentTitle}` : segmentTitle;
};

const segmentTitleTextKey = {
    [PaymentsTabActiveSegment.Overview]: TextKey.PaymentsTabSegmentTitleOverview,
    [PaymentsTabActiveSegment.Requests]: TextKey.PaymentRequestPlural,
    [PaymentsTabActiveSegment.Methods]: TextKey.PaymentMethodPlural,
    [PaymentsTabActiveSegment.Plans]: TextKey.PaymentPlanPlural,
};
